var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.4585,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#2F2D83",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.684 26.4405V24.2445L13.464 22.9485L16.236 21.9765V21.9045L13.464 20.9145L9.684 19.6185V17.4225L18.918 21.0045V22.8765L9.684 26.4405ZM20.3012 26.4405V24.2445L24.0812 22.9485L26.8532 21.9765V21.9045L24.0812 20.9145L20.3012 19.6185V17.4225L29.5352 21.0045V22.8765L20.3012 26.4405Z",
    fill: "#2F2D83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightright);
export default __webpack_public_path__ + "static/media/rightright.5065588a1885fe887349df9485f4fc41.svg";
export { ForwardRef as ReactComponent };